<app-navbar></app-navbar>
<app-loader *ngIf="loaderService.loader"></app-loader>
<div class="loader-transition" [class]="loaderService.loader?'loader-opaq':''">
    <router-outlet></router-outlet>
</div>
